import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import CollectionListV2 from '@features/collection/components/CollectionListV2';
import DesignListV2 from '@features/design/components/DesignListV2';

import { clearFilterResponse, storeInitialItemInGlobalFilter } from '@store/actions/FilterAction';

import { getUserInfo, onGetSystemPreferences } from '@utils/Util';

const DesignList = () => {
	const { pathname } = useLocation();
	const [defaultViewType, setDefaultViewType] = useState(null);
	const [selectedTab, setSelectedTab] = useState('COLLECTION_TAB');
	const dispatch = useDispatch();
	const filterData = useSelector((store) => store.filterFieldStore);
	const [designIdToView, setDesignIdToView] = useState(null);
	const [isSetParamExist, setIsSetParamExist] = useState(false);
	const location = useLocation();

	const DEFAULT_STATE_FOR_ALL = {
		availabilityStatusList: [
			{
				key: 'All',
				name: 'availabilityStatusList',
				value: 'ALL',
				type: 'SELECT',
				isHideChip: true
			}
		]
	};

	useEffect(() => {
		const activePathName =
			pathname === '/nitex-studio'
				? onGetSystemPreferences().NITEX_PAGE_TAB_VIEW
				: onGetSystemPreferences().COLLECTION_PAGE_TAB_VIEW;
		const params = new URLSearchParams(location.search);
		const selectedProductId = params.get('productId');
		const isSetProduct = params.get('isSet');
		if (selectedProductId) {
			setDesignIdToView(selectedProductId);
			if (isSetProduct !== null) {
				setIsSetParamExist(isSetProduct === 'true');
			}
			setSelectedTab('DESIGN_TAB');
		} else {
			if (pathname === '/nitex-studio') {
				const designType = params.get('designType');
				let tabToSet = designType === 'SOLD' ? 'DESIGN_TAB' : activePathName;
				setSelectedTab(tabToSet);
			} else {
				setSelectedTab(activePathName);
			}
		}
	}, [pathname, location.search]);

	useEffect(() => {
		if (!filterData?.availabilityStatusList && selectedTab) {
			dispatch(storeInitialItemInGlobalFilter(DEFAULT_STATE_FOR_ALL));
		}
	}, [selectedTab, filterData]);

	useEffect(() => {
		onSetDefaultView(getUserInfo()?.systemPreference?.collectionDetailsViewType);
		localStorage.setItem('fromRoute', pathname);
	}, []);

	const onSetDefaultView = (type) => {
		setDefaultViewType(type);
	};

	const onChangeTab = (value) => {
		if (selectedTab !== value) {
			dispatch(clearFilterResponse());
			setSelectedTab(value);
		}
	};

	return (
		<>
			{selectedTab === 'COLLECTION_TAB' || selectedTab === 'SUGGESTED_FOR_BUYER' ? (
				<CollectionListV2
					selectedTab={selectedTab}
					onClickTab={(value) => onChangeTab(value)}
					onSetDefaultView={(value) => onSetDefaultView(value)}
					pathName={pathname}
				/>
			) : (
				<DesignListV2
					selectedTab={selectedTab}
					viewType={defaultViewType}
					onClickTab={(value) => onChangeTab(value)}
					onSetDefaultView={(value) => onSetDefaultView(value)}
					pathName={pathname}
					selectedProductId={designIdToView}
					isSetParamExist={isSetParamExist}
					setIsSetParam={setIsSetParamExist}
				/>
			)}
		</>
	);
};

export default React.memo(DesignList);
